/**
 * Application version — single source of truth for the WEB app.
 *
 * Update APP_VERSION and RELEASE_DATE on every production release, and add a
 * matching entry to RELEASE_HISTORY (newest first). The Footer, Release Notes
 * page, and any other version display read from here, so there is only one
 * place to change.
 *
 * NOTE: This is the web platform version. The mobile Android APK has its own
 * version in src/mobile/appConstants.js and is managed separately.
 */

// Current production version (frozen for the v1.0 release).
export const APP_VERSION = '1.0.0';
export const RELEASE_DATE = 'September 3, 2026';

/**
 * Release history — newest first. Each entry drives the Release Notes page.
 * On every release, prepend a new entry with:
 *   { version, date, title, summary, highlights: [], fixes: [] }
 */
export const RELEASE_HISTORY = [
  {
    version: '1.0.0',
    date: 'September 3, 2026',
    title: 'Initial Production Release',
    summary:
      'First production release of ISops — a complete IT Service Operations platform ' +
      'covering the service desk, asset lifecycle, infrastructure provisioning, vendor ' +
      'and financial governance, CMDB, and role-based dashboards.',
    highlights: [
      'Service Desk & ITSM: tickets, SLA management, problem management, knowledge base, service portal, 64+ notification types',
      'Asset Management: inventory, allocation (with linked devices), configuration & components, lifecycle engine, dynamic categories & OEM/manufacturer management',
      'Asset finance: ownership types (Purchased/Rental/Lease), ADP warranty tracking, 16 asset reports, dedicated asset dashboard',
      'Infrastructure Provisioning: multi-stage server provisioning, VPN access management, hardware & software request workflows, SAM',
      'Vendor & Financial Governance: vendor lifecycle & risk analytics, contract management, budgets',
      'Infrastructure Management: CMDB (CI, topology, impact analysis), locations, warehouse & stock, maintenance, repair center, backups',
      'Administration & Security: 7 roles with 100+ granular permissions, audit logging, security alert detectors, system health',
      'Dashboards & Reporting: role-adaptive home dashboard, ICT management dashboard, deep analytics, consolidated reports',
      'Hardware acceptance forms with employee + engineer digital signatures',
    ],
    fixes: [
      'Hardware request acceptance: signing the acceptance form now completes the request',
      'Hardware allocation: primary and linked devices are both assigned to the employee',
      'Acceptance form: the main device (e.g. laptop) is shown as the primary device, peripherals as linked',
      'Start Provisioning no longer errors for requests raised by category/brand without a catalog item',
      'Theme presets recolor the app consistently; tables and sidebar follow the selected theme',
      'Server Requests list now shows the Request ID column',
    ],
  },
];
